import { createContext, useState, useRef } from "react";

export const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState({
    message: null,
    type: "error",
    onDissmissFunc: null,
  });

  const onDissmissFuncRef = useRef(null);

  const handleAlert = (message, type = "info", onDissmissFunc = null) => {
    setAlert({ message, type, onDissmissFunc });
    onDissmissFuncRef.current = onDissmissFunc;
    setTimeout(() => clearAlert(), 5000);
  };

  const clearAlert = () => {
    setAlert({ message: null, type: "error" });
    if (typeof onDissmissFuncRef.current === "function") {
      onDissmissFuncRef.current();
    }
  };

  return (
    <AlertContext.Provider value={{ alert, handleAlert, clearAlert }}>
      {children}
    </AlertContext.Provider>
  );
};
